import { render, staticRenderFns } from "./specific-shopify.vue?vue&type=template&id=9e13fc72&"
import script from "./specific-shopify.vue?vue&type=script&lang=js&"
export * from "./specific-shopify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports